import Link from 'next/link'
import * as fcl from '@onflow/fcl'
import {useAppContext} from 'context/AppContext'

const NavbarLink = ({target, href, children}) => (
  <Link href={href}>
    <a
      target={target}
      className="inline-block uppercase hover:text-pink-500 hover:text-underline text-center align-middle p-2 h-auto md:p-4 mx-4 transform hover:scale-125 duration-300 ease-in-out"
    >
      {children}
    </a>
  </Link>
)

export default function Navbar() {
  var {user, hasCollection, setIsLoading} = useAppContext()

  const logIn = async () => {
    setIsLoading(true)
    try {
      const loginResponse = await fcl.authenticate()
      console.log('loginResponse', loginResponse)
    } catch (e) {
      console.error(e)
    }
    setIsLoading(false)
  }

  const logOut = async () => {
    fcl.unauthenticate()
  }

  return (
    <div className="relative w-full font-graveside fixed z-50">
      <div className="absolute inset-0 opacity-75 -z-10"></div>
      <div className="flex items-center p-2">
        <Link href="/">
          <a className="absolute">
            <img className="w-0 md:w-40" src={`https://arenaboyz.blob.core.windows.net/$web/Static/crypthulhu-logo.png`} />
          </a>
        </Link>

        <div className="md:ml-40 w-full flex justify-end">
          {user?.loggedIn ? (
            <button className="btn" onClick={logOut}>
              LOG OUT
            </button>
          ) : (
            <button className="btn" onClick={logIn}>
              CONNECT WALLET
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
